import { Navigate } from "react-router-dom";

export default function AiVipSubscriptionsPage() {
  return <Navigate to="/ai/vip/subscription-orders" replace />;
}
